import { LOAD_MONITORING_DATA } from '../constants'

const monitoring = (state={}, action) => {
  switch(action.type) {
    case LOAD_MONITORING_DATA:
      return {...action.data}
    default:
      return state;
  }
}

export default monitoring


// WEBPACK FOOTER //
// ./src/admin/statuses/javascripts/reducers/monitoringReducer.js